import React, { useState, useEffect, useRef } from 'react';
import logo from '../../space.webp';
import Cookies from 'universal-cookie';
import './editViews.css';

import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes, _arrayBufferToBase64 } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import clip from './../../img/clip.png';
import home from './../../img/home.png';
import persons from './../../img/profile.png';
import car from './../../img/car.png';
import company from './../../img/company.png';
import crime from './../../img/crime.png';
import phoneInterner from './../../img/phoneInterner.png';
import event from './../../img/ors.png';
import documents from './../../img/document.png';
import weapon from './../../img/weapon.png';
import bs from './../../img/bs.png';
import headPhone from './../../img/headphone.png';
import plus from './../../img/plus.png'
import minus from './../../img/minus.png'
import PersonModel from '../models/PersonModel';
import SearchModel from '../models/SearchModel';
import ModelForAdd from '../models/ModelForAdd';

import Person from '../components/Person';
import Address from '../components/Address';
import Company from '../components/Company';
import Auto from '../components/Auto';
import Contact from '../components/Contact';
import Document from '../components/Document';
import Gun from '../components/Gun';
import Proceedings from '../components/Proceedings';
import Traitor from '../components/Traitor';
import BS from '../components/BS';
import Kan from '../components/Kan';
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { Buffer } from 'buffer'
import {
    createChecker, createCheckerLabel, createCheckerInput,
    createPerson, createTraitor, createPersonCollapsed, createTraitorCollapsed,
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed,
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed,
    showError
} from '../ViewCreator';
import AddressModel from '../models/AddressModel';
import AutoModel from '../models/AutoModel';
import CompanyModel from '../models/CompanyModel';
import ContactModel from '../models/ContactModel';
import DocumentModel from '../models/DocumentModel';
import GunModel from '../models/GunModel';
import OPMModel from '../models/OPMModel';
import TraitorModel from '../models/TraitorModel';
import KanModel from '../models/KanModel';
import BSModel from '../models/BSModel';
import MyDropzone from '../components/MyDropzone';

var modelForAdd = (new ModelForAdd());
var personModel = (new PersonModel());
const cookies = new Cookies();
function OPMEdit() {

    var searchModel = new SearchModel();

    const editor = useRef();
    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };

    const [isBlocked, setIsBlocked] = useState(false);

    const blockUI = () => {
        setIsBlocked(true);
    };

    const unblockUI = () => {
        setIsBlocked(false);
    };

    const [type, setType] = useState(0);

    const mainSubmit = () => {
        window.location.href = "/main";
    };

    const addNew = (id, type) => {
        
        clearPersonModel()
        if (type === 20000) {
            var per = new PersonModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.persons.push(per);
        } else if (type === 20001) {
            var per = new AddressModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.address.push(per);
        } else if (type === 20002) {
            var per = new AutoModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.auto.push(per);
        } else if (type === 20003) {
            var per = new CompanyModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.company.push(per);
        } else if (type === 20004) {
            var per = new ContactModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.contact.push(per);
        } else if (type === 20005) {
            var per = new DocumentModel()
            per.id = id
            personModel.documents.push(per);
        } else if (type === 20006) {
            var per = new GunModel()
            per.id = id
            personModel.gun.push(per);
        } else if (type === 20008) {
            var per = new OPMModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.opm.push(per);
        } else if (type === 20009) {
            var per = new TraitorModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.traitors.push(per);
        } else if (type === 20010) {
            var per = new KanModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.kan.push(per);
        } else if (type === 20011) {
            var per = new BSModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.bs.push(per);
        } else if (type === 20012){
            var files = id
            for (let index = 0; index < files.length; index++) {
                const reader = new FileReader()
                reader.onabort = () => console.log('file reading was aborted')
                reader.onerror = () => console.log('file reading has failed')
                reader.onload = () => {
                // Do whatever you want with the file contents
                  const binaryStr = reader.result
                  var ex = "";
                  if (files[index].path == undefined) {
                    ex = files[index].name.split('.').pop().toLowerCase();
                  } else {
                    ex = files[index].path.split('.').pop().toLowerCase();
                  }
                  if (ex == 'bmp' || ex == 'gif' || ex == 'jpeg' || ex == 'jpg' || ex == 'tiff' || ex == 'png') {
                    var b = _arrayBufferToBase64(binaryStr)
                    var tt = {
                      image: b,
                      text: ""
                    }
                    personModel.photo.push(tt)
                    
                    
                  } else {
            
            
            
            
            
                    
                    var b = _arrayBufferToBase64(binaryStr)
            
            
            
            
                    
                    var tt = {
                      
                        fileName: files[index].name,
                        file: b,
                      
                      
                      text: "",
                      
                    }

                    
                      personModel.files.push(tt)
                    
                  }

                  sendReSave()
                }
                reader.readAsArrayBuffer(files[index])
              }
           
        } else if (type === 20013){
            var tt = {
                image: id,
                text: ""
              }
            personModel.photo.push(tt)
        }

        if (type !== 20012){
         sendReSave()
        }
    }

    useEffect(() => {
        if (cookies.get('type') != null) {
            var t = cookies.get('type')
            setType(t);
        }
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        sendPerson(id);
    }, []);

    const sendPerson = (id) => {
        var path = ip + '/api/opm/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                    
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []

                    var pers = result.data
                    personModel = (pers)
                    setView(pers)

                }
            })
    }

    const profileSubmit = () => {
        allHide();
        document.getElementById("Person").style.display = "block";
        document.getElementById("personsB").className = 'panelButtonActive-opm'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const homeSubmit = () => {
        allHide();
        document.getElementById("Address").style.display = "block";
        document.getElementById("homeB").className = 'panelButtonActive-opm'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const carSubmit = () => {
        allHide();
        document.getElementById("Auto").style.display = "block";
        document.getElementById("carB").className = 'panelButtonActive-opm'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const companySubmit = () => {
        allHide();
        document.getElementById("Company").style.display = "block";
        document.getElementById("companyB").className = 'panelButtonActive-opm'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const phoneInternerSubmit = () => {
        allHide();
        document.getElementById("Contact").style.display = "block";
        document.getElementById("phoneInternerB").className = 'panelButtonActive-opm'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const clipSubmit = () => {
        allHide();
        document.getElementById("MyDropzone").style.display = "block";
        document.getElementById("clipB").className = 'panelButtonActive-opm'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const eventSubmit = () => {
        allHide();
        document.getElementById("Proceedings").style.display = "block";
        document.getElementById("eventB").className = 'panelButtonActive-opm'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const traitorSubmit = () => {
        allHide();
        document.getElementById("Traitor").style.display = "block";
        document.getElementById("crimeB").className = 'panelButtonActive-opm'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const kanzSubmit = () => {
        allHide();
        document.getElementById("Kan").style.display = "block";
        document.getElementById("headPhoneB").className = 'panelButtonActive-opm'
        changeAdded()
        var a = document.getElementById("foundItems");
        a.innerHTML = ""
    }

    const allHide = () => {
        var a = document.getElementsByClassName("menuItems");
        for (let index = 0; index < a.length; index++) {
            a[index].style.display = "none";

        }
        var b = document.getElementsByClassName("panelButtonActive-opm");
        for (let index = 0; index < b.length; index++) {
            b[index].className = 'panelButton-opm'

        }
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }

    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id + "A")
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "AList").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "AList").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id + "A").value = l[index]
                            document.getElementById(id + "AList").innerHTML = "";

                            if (id == 'numberOPM') {
                                personModel.numberOPM = l[index]
                            }
                            if (id == 'ini_organ') {
                                personModel.ini_organ = l[index]
                            }
                            if (id == 'ini_direction') {
                                personModel.ini_direction = l[index]
                            }
                            if (id == 'ini_name') {
                                personModel.ini_name = l[index]
                            }
                            if (id == 'executor') {
                                personModel.executor = l[index]
                            }
                            if (id == 'storage') {
                                personModel.storage = l[index]
                            }
                            if (id == 'dateOPM') {
                                personModel.dateOPM = l[index]
                            }
                            if (id == 'typeExecutor') {
                                personModel.typeExecutor = l[index]
                            }


                        }
                        document.getElementById(id + "AList").appendChild(z);

                    }
                }
            })








    }


    const storagechange = () => {
        personModel.storage = document.getElementById('storageA').value
        changedfield('storage');
    }
    const ini_namechange = () => {
        personModel.ini_name = document.getElementById('ini_nameA').value
        changedfield('ini_name');
    }
    const ini_directionchange = () => {
        personModel.ini_direction = document.getElementById('ini_directionA').value
        changedfield('ini_direction');
    }
    const ini_organchange = () => {
        personModel.ini_organ = document.getElementById('ini_organA').value
        changedfield('ini_organ');
    }
    const executorchange = () => {
        personModel.executor = document.getElementById('executorA').value
        changedfield('executor');
    }
    const typeExecutorchange = () => {
        personModel.typeExecutor = document.getElementById('typeExecutorA').value
        changedfield('typeExecutor');
    }
    const dateOPMchange = () => {
        personModel.dateOPM = document.getElementById('dateOPMA').value
        changedfield('dateOPM');
    }
  
    const numberOPMchange = () => {
        personModel.numberOPM = document.getElementById('numberOPMA').value
        changedfield('numberOPM');
    }

    const handleFocus = (event) => {
        closeAllHelp()
    };

    const sendSave = () => {
        blockUI()
        var path = ip + '/api/opm/addData';

        personModel.persons = []
        personModel.address = []
        personModel.auto = []
        personModel.company = []
        personModel.contact = []
        personModel.documents = []
        personModel.gun = []
        personModel.opm = []
        personModel.photo = []
        personModel.files = []
        personModel.traitor = []

        if (personModel.numberOPM == undefined || personModel.numberOPM == ''){
            showError('Номер не може бути пустим')
            return;
          }
    
          if (personModel.dateOPM == undefined || personModel.dateOPM == ''){
            showError('Дата не може бути пустою')
            return;
          }
    
          if (personModel.typeExecutor == undefined || personModel.typeExecutor == ''){
            showError('Підрозділ виконавця не може бути пустим')
            return;
          }




        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                }
            })
    }

    const sendRemove = (inner) => {
        blockUI()
        var path = ip + '/api/opm/removeData';

        var bd = encryptAes(JSON.stringify(inner))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);
                    document.getElementById("addeditems").innerHTML = "";
                    personModel = (result.data)
                    setView(result.data)

                }
            })
    }

    const handleSubmit = (e) => {
        sendSave()

        e.preventDefault();
    }

    const getAvatar = async (id) => {
        var path = ip + '/files/avatar';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);


                    var a = document.getElementById('image' + id)
                    a.src = 'data:image/png;base64,' + result.data
                    a.className = 'prevImageSearch'
                }
            })

    }

    const getAvatarToComponent = async(id, style, el) => {
        var path = ip + '/files/avatar';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);


                    var a = document.getElementById('image' + id)
                   

                    if (a !== null) {
                        a.src = 'data:image/png;base64,'+result.data
                        a.className = style
                      }
                       el.src = 'data:image/png;base64,'+result.data
                       el.className = style
                }
                
              
          }   
      )
    }

    const sendReSave = () => {
        blockUI()
        var path = ip + '/api/opm/addData';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    personModel = (result.data)
                    setView(result.data)

                }
            })
    }

    const sendPersonFullScreen = (id) => {
        window.open("/person?id=" + id)
    }

    const sendAddressFullScreen = (id) => {
        window.open("/address?id=" + id)
    }
    const sendAutoFullScreen = (id) => {
        window.open("/auto?id=" + id)
    }
    const sendCompanyFullScreen = (id) => {
        window.open("/company?id=" + id)
    }
    const sendContactFullScreen = (id) => {
        window.open("/contact?id=" + id)
    }
    const sendOPMFullScreen = (id) => {
        window.open("/opm?id=" + id)
    }
    const sendDocFullScreen = (id) => {
        window.open("/document?id=" + id)
    }
    const sendGunFullScreen = (id) => {
        window.open("/gun?id=" + id)
    }
    const sendTraitorFullScreen = (id) => {
        window.open("/traitor?id=" + id)
    }
    const sendKanFullScreen = (id) => {
        window.open("/kan?id=" + id)
    }
    const sendBSFullScreen = (id) => {
        window.open("/bs?id=" + id)
    }

    function clearPersonModel() {
        personModel.persons = []
        personModel.address = []
        personModel.auto = []
        personModel.company = []
        personModel.contact = []
        personModel.contacts = []
        personModel.documents = []
        personModel.gun = []
        personModel.guns = []
        personModel.opms = []
        personModel.opm = []
        personModel.photos = []
        personModel.photo = []
        personModel.files = []
        personModel.docs = []
        personModel.kan = []
        personModel.bs = []
        personModel.traitors = []
    }


    const changeSearch = (inner) => {

        var a = document.getElementById("foundItems");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            var z = document.createElement('div'); // is a node
            var vv = document.createElement('div');
            vv.className = "itemAddView"
            z.style.display = "table";
            vv.style.display = "table-cell";
            inner[index].style = "table-cell"
            var vb = document.createElement('div');
            vb.className = "itemAddButton"
            vb.innerHTML = "<img width=\"100%\" src=\"" + plus + "\"/>"
            if (document.getElementById("Person").style.display == "block") {
                var temp = modelForAdd.person
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.person.length; j++) {
                        if (modelForAdd.person[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.persons.push(inner[index].value);
                        sendReSave()
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

            if (document.getElementById("Address").style.display == "block") {
                var temp = modelForAdd.address
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.address.length; j++) {
                        if (modelForAdd.address[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.address.push(inner[index].value);
                        sendReSave()
                        temp.push(inner[index])
                        changeAdded();
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

            if (document.getElementById("Auto").style.display == "block") {
                var temp = modelForAdd.auto
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.auto.length; j++) {
                        if (modelForAdd.auto[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.auto.push(inner[index].value);
                        sendReSave()
                        temp.push(inner[index])
                        changeAdded();
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

            if (document.getElementById("Company").style.display == "block") {
                var temp = modelForAdd.company
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.company.length; j++) {
                        if (modelForAdd.company[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.company.push(inner[index].value);
                        sendReSave()
                        temp.push(inner[index])
                        changeAdded();
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

            if (document.getElementById("Contact").style.display == "block") {
                var temp = modelForAdd.contact
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.contact.length; j++) {
                        if (modelForAdd.address[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.contact.push(inner[index].value);
                        sendReSave()
                        temp.push(inner[index])
                        changeAdded();
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

            if (document.getElementById("Proceedings").style.display == "block"){
            
                        var temp = modelForAdd.proceedings
                        
                       
                        const cl = i => () =>{
                            if (modelForAdd.proceedings == undefined ) {
                          var b = true;
                          for (let j = 0; j <modelForAdd.proceeding.length; j++) {
                            if ( modelForAdd.proceeding[j].value == inner[index].value){
                              b = false
                            }
                          }
                          if (b) {
                           clearPersonModel()
                          inner[index].value.relStatus = 0
                          inner[index].value.relDesk = ""
                          personModel.proceedings = (inner[index].value);
              
                          sendReSave(personModel)
              
                           // temp = (inner[index])
                            changeAdded();
                          } else {
                            showError('Данний запис уже існує');
                          }
                        } else {
                            showError('В завдання може бути добавлена тільки одна справа')
                        }
                        }
              
                      
                        vb.onclick = cl(inner[index].value)
                      }
           
            if (document.getElementById("Kan").style.display == "block") {
                var temp = modelForAdd.kan
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.kan.length; j++) {
                        if (modelForAdd.kan[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.kan.push(inner[index].value);
                        sendReSave()
                        temp.push(inner[index])
                        changeAdded();
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

            if (document.getElementById("Traitor").style.display == "block") {
            var temp = modelForAdd.traitors
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.traitors.length; j++) {
                        if (modelForAdd.traitors[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.traitors.push(inner[index].value);
                        sendReSave()
                        temp.push(inner[index])
                        changeAdded();
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }

           
            vv.appendChild(vb)
            z.appendChild(vv);
            z.appendChild(inner[index]);
            a.appendChild(z);

        }
    }

    const resetModel = () => {
        modelForAdd = new ModelForAdd()
    };

    const setView = (pers, obj) => {
        document.getElementById('numberOPMA').value = pers.numberOPM
        document.getElementById('ini_organA').value = pers.ini_organ
        document.getElementById('ini_directionA').value = pers.ini_direction
        document.getElementById('ini_nameA').value = pers.ini_name
        document.getElementById('executorA').value = pers.executor
        document.getElementById('storageA').value = (pers.storage == undefined ? '' : pers.storage) 
        document.getElementById('dateOPMA').value = pers.dateOPM
        document.getElementById('typeExecutorA').value = pers.typeExecutor
        editor.current.setContents(pers.infoOPM)
        resetModel()
        if (pers.persons.length > 0) {

            for (let index = 0; index < pers.persons.length; index++) {
                addNewPerson(pers.persons[index].person, false)
                modelForAdd.person[modelForAdd.person.length - 1].value.relDesk = pers.persons[index].text
                modelForAdd.person[modelForAdd.person.length - 1].value.relStatus = pers.persons[index].type

            }
        }

        if (pers.address.length > 0) {

            for (let index = 0; index < pers.address.length; index++) {
                addNewAddress(pers.address[index].address, false)
                modelForAdd.address[modelForAdd.address.length - 1].value.relDesk = pers.address[index].text
                modelForAdd.address[modelForAdd.address.length - 1].value.relStatus = pers.address[index].type

            }
        }

        if (pers.auto.length > 0) {

            for (let index = 0; index < pers.auto.length; index++) {
                addNewAuto(pers.auto[index].auto, false)
                modelForAdd.auto[modelForAdd.auto.length - 1].value.relDesk = pers.auto[index].text
                modelForAdd.auto[modelForAdd.auto.length - 1].value.relStatus = pers.auto[index].type

            }
        }

        if (pers.company.length > 0) {

            for (let index = 0; index < pers.company.length; index++) {
                addNewCompany(pers.company[index].company, false)
                modelForAdd.company[modelForAdd.company.length - 1].value.relDesk = pers.company[index].text
                modelForAdd.company[modelForAdd.company.length - 1].value.relStatus = pers.company[index].type

            }
        }

        if (pers.contacts.length > 0) {

            for (let index = 0; index < pers.contacts.length; index++) {
                addNewContact(pers.contacts[index].contact, false)
                modelForAdd.contact[modelForAdd.contact.length - 1].value.relDesk = pers.contacts[index].text
                modelForAdd.contact[modelForAdd.contact.length - 1].value.relStatus = pers.contacts[index].type

            }
        }


        if(pers.proceedings.id >= 0){
            addNewProceedings(pers.proceedings, false)
            }

        if (pers.photos.length > 0) {

            for (let index = 0; index < pers.photos.length; index++) {
                addNewPhoto(pers.photos[index], false)

            }
        }

        if (pers.arch.length > 0) {

            for (let index = 0; index < pers.arch.length; index++) {
                  addNewFile(pers.arch[index], false)

            }
        }

        if (pers.kan.length > 0) {

            for (let index = 0; index < pers.kan.length; index++) {
                addNewKan(pers.kan[index].kan, false)
                modelForAdd.kan[modelForAdd.kan.length - 1].value.relDesk = pers.kan[index].text
                modelForAdd.kan[modelForAdd.kan.length - 1].value.relStatus = pers.kan[index].type

            }
        }

        if (pers.traitors.length > 0) {

            for (let index = 0; index < pers.traitors.length; index++) {
                addNewTraitors(pers.traitors[index].traitor, false)
                modelForAdd.traitors[modelForAdd.traitors.length - 1].value.relDesk = pers.traitors[index].text
                modelForAdd.traitors[modelForAdd.traitors.length - 1].value.relStatus = pers.traitors[index].type

            }
        }
       
        changeAdded()
    }

    const addNewProceedings = (pers, isNewAdd = true) => {
            var z = document.createElement('div'); // is a node
            z.className = "listItem"
            var s = "<p align=\"left\">";
            var sn =  (pers.numberProceedings == undefined || pers.numberProceedings == '' ? "" : pers.numberProceedings + " ")+ 
                      (pers.typeProceedings == undefined || pers.typeProceedings == '' ? "" : pers.typeProceedings + " ")+
                      (pers.dateProceedings == undefined || pers.dateProceedings == '' ? "" : pers.dateProceedings + " ");
            var sb = (pers.fabulaProceedings == undefined || pers.fabulaProceedings == '' ? "" : pers.fabulaProceedings + " ");
            s += (sn == undefined || sn == '' ? "" : sn + "<br>")+
                 (sb == undefined || sb == '' ? "" : sb + "<br>");
            z.innerHTML = s
            z.style.display = "block";
            
      
            z.value = Object.assign({}, pers);
      
            var p = Object.assign({}, pers);
      
            if (p.numberProceedings == undefined || p.numberProceedings == ''){
              z.value = pers
              p = pers
              
            }
      
            if (p.numberProceedings == undefined || p.numberProceedings == ''){
              showError('Номер не може бути пустим')
              return;
            }
      
            if (p.dateProceedings == undefined || p.dateProceedings == ''){
                showError('Дата не може бути пустою')
              return;
            }
      
            if (p.typeProceedings == undefined || p.typeProceedings == ''){
                showError('Тип справи не може бути пустим')
              return;
            }
      
            
      
      
            if (isNewAdd){
                  
                clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""
            modelForAdd.proceedings = (z.value)
                    personModel.proceedings = (z.value);
                    
                  sendReSave(personModel)
            }else {
              modelForAdd.proceedings = (z)
              
              changeAdded()
            }
          }

    const addNewPerson = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.lastName == undefined || pers.lastName == '' ? "" : pers.lastName + " ") +
            (pers.firstName == undefined || pers.firstName == '' ? "" : pers.firstName + " ") +
            (pers.middleName == undefined || pers.middleName == '' ? "" : pers.middleName + " ");
        var sb = (pers.bDate == undefined || pers.bDate == '' ? "" : pers.bDate + " ") +
            (pers.bLocation == undefined || pers.bLocation == '' ? "" : pers.bLocation + " ");
        var sc = (pers.nationality == undefined || pers.nationality == '' ? "" : pers.nationality + " ") +
            (pers.citizen == undefined || pers.citizen == '' ? "" : pers.citizen + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>") +
            (sb == undefined || sb == '' ? "" : sb + "<br>") +
            (sc == undefined || sc == '' ? "" : sc + "<br>") +
            (pers.nikName == undefined || pers.nikName == '' ? "" : pers.nikName + "<br>");

        if (pers.criminal == undefined || pers.criminal == '') {
            pers.criminal = 'Ні'
        }

        if (pers.criminal == "Так") {
            s += "Cудимий<br>"
        }
        s += (pers.desc == undefined || pers.desc === '' ? "" : pers.desc + "<br>");
        z.innerHTML = s
        z.style.display = "block";

        z.value = Object.assign({}, pers);


        var p = Object.assign({}, pers);
        if (p.firstName == undefined || p.firstName == '') {
            z.value = pers
            p = pers

        }

        if (p.firstName == undefined || p.firstName == '') {
            showError('Ім\'я зв\'язка не може бути пустим')
            return;
        }

        if (p.lastName == undefined || p.lastName == '') {
            showError('Прізвище зв\'язка не може бути пустим')
            return;
        }

        if (p.middleName == undefined || p.middleName == '') {
            showError('По батькові зв\'язка не може бути пустим')
            return;
        }

        if (p.bDate == undefined || p.bDate == '') {
            showError('Рік народження зв\'язка не може бути пустим')
            return;
        }


        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.persons.push(z.value);

            sendReSave()
        } else {

            modelForAdd.person.push(z)

            changeAdded()
        }
    }

    const addNewAddress = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.region == undefined || pers.region == '' ? "" : pers.region + " ") +
            (pers.ato == undefined || pers.ato == '' ? "" : pers.ato + " ") +
            (pers.np == undefined || pers.np == '' ? "" : pers.np + " ");
        var sb = (pers.street == undefined || pers.street == '' ? "" : pers.street + " ") +
            (pers.buiding == undefined || pers.buiding == '' ? "" : pers.buiding + " ") +
            (pers.flat == undefined || pers.flat == '' ? "" : pers.flat + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>") +
            (sb == undefined || sb == '' ? "" : sb + "<br>");
        s += (pers.descAddress == undefined ? "" : pers.descAddress + "<br>");
        z.innerHTML = s
        z.style.display = "block";
        z.value = Object.assign({}, pers);

        var p = Object.assign({}, pers);
        if (p.street == undefined || p.street == '') {
            z.value = pers
            p = pers

        }
        if (p.street == undefined || p.street == '') {
            showError('Вулиця не може бути пустою')
            return;
        }

        if (p.buiding == undefined || p.buiding == '') {
            showError('Будинок не може бути пустим')
            return;
        }

        if (p.np == undefined || p.np == '') {
            showError('НП не може бути пустим')
            return;
        }

        if (p.ato == undefined || p.ato == '') {
            showError('АТО не може бути пустим')
            return;
        }

        if (p.region == undefined || p.region == '') {
            showError('Регіон не може бути пустим')
            return;
        }


        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.address.push(z.value);

            sendReSave()
        } else {

            modelForAdd.address.push(z)

            changeAdded()
        }
    }

    const addNewAuto = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.model == undefined || pers.model == '' ? "" : pers.model + " ") +
            (pers.number == undefined || pers.number == '' ? "" : pers.number + " ") +
            (pers.color == undefined || pers.color == '' ? "" : pers.color + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>");
        s += (pers.descAuto == undefined ? "" : pers.descAuto + "<br>");
        z.innerHTML = s
        z.style.display = "block";
        z.value = Object.assign({}, pers);
        var p = Object.assign({}, pers);
        if (p.model == undefined || p.model == '') {
            z.value = pers
            p = pers

        }

        if (p.model == undefined || p.model == '') {
            showError('Марка не може бути пустою')
            return;
        }

        if (p.number == undefined || p.number == '') {
            showError('Номер не може бути пустим')
            return;
        }

        if (p.color == undefined || p.color == '') {
            showError('Колір не може бути пустим')
            return;
        }

        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.auto.push(z.value);

            sendReSave()
        } else {
            modelForAdd.auto.push(z)

            changeAdded()
        }
    }

    const addNewCompany = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.nameCompany == undefined || pers.nameCompany == '' ? "" : pers.nameCompany + " ") +
            (pers.activity == undefined || pers.activity == '' ? "" : pers.activity + " ") +
            (pers.orpo == undefined || pers.orpo == '' ? "" : pers.orpo + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>");
        s += (pers.descCompany == undefined ? "" : pers.descCompany + "<br>");
        z.innerHTML = s
        z.style.display = "block";
        z.value = Object.assign({}, pers);

        var p = Object.assign({}, pers);
        if (p.nameCompany == undefined || p.nameCompany == '') {
            z.value = pers
            p = pers

        }
        if (p.nameCompany == undefined || p.nameCompany == '') {
            showError('Назва не може бути пустою')
            return;
        }

        if (p.activity == undefined || p.activity == '') {
            showError('Діяльність не може бути пустою')
            return;
        }



        if (isNewAdd) {
            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.company.push(z.value);

            sendReSave()
        } else {
            modelForAdd.company.push(z)

            changeAdded()
        }
    }

    const addNewContact = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.contactKey == undefined || pers.contactKey == '' ? "" : pers.contactKey + ": <br>") +
            (pers.contactValue == undefined || pers.contactValue == '' ? "" : pers.contactValue + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>");
        s += (pers.descContact == undefined ? "" : pers.descContact + "<br>");
        z.innerHTML = s
        z.style.display = "block";
        z.value = Object.assign({}, pers);

        var p = Object.assign({}, pers);
        if (p.contactKey == undefined || p.contactKey == '') {
            z.value = pers
            p = pers

        }
        if (p.contactKey == undefined || p.contactKey == '') {
            showError('Тип не може бути пустим')
            return;
        }

        if (p.contactValue == undefined || p.contactValue == '') {
            showError('Значення не може бути пустим')
            return;
        }

        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""
            personModel.contact.push(z.value);

            sendReSave()
        } else {
            modelForAdd.contact.push(z)

            changeAdded()
        }
    }

    const addNewPhoto = (files, isNewAdd) => {
          
    
            var z = document.createElement('div'); // is a node
            z.className = "listItem"
            //d.className = 'prevView'
            var adr = document.createElement('div');
    
            
            var element = new Image();
           // element.src =  'data:image/png;base64,'+files.image
            
           // element.className = 'prevImage'
    
           element.src = loading
           element.className = 'prevImageSearchEmpty'
           if (element.id !== undefined) {
           element.id = 'image'+files.id
           
           getAvatarToComponent(files.id, 'prevImage', element)
          }
    
    
            z.appendChild(element)
    
            
            z.style.display = "block";
            var tt = {
              id: files.id,
              image: files.image,
              text: files.text
            }
            z.value = tt
            
            
            if (isNewAdd){
                
              clearPersonModel()
              z.value.relStatus = 0
              z.value.relDesk = ""
                  
                    personModel.photo.push(z.value);
                    
                  sendReSave(personModel)
    
                  
            } else {
      
              modelForAdd.photo.push(z)
            
            changeAdded()
    
            
            }
    }

    const addNewFile = (files, isNewAdd) => {
          
    
      var z = document.createElement('div'); // is a node
            z.className = "listItem"
            //d.className = 'prevView'
            var file = document.createElement('div');
    
            file.innerHTML = files.archive.fileName
    
            
    
            z.appendChild(file)
    
    
      
      z.style.display = "block";
      var tt = {
        id: files.archive.id,
        file: files.archive.file,
        text: files.text,
        fileName: files.archive.fileName
      }
      z.value = tt
      
      if (isNewAdd){
                
        clearPersonModel()
        z.value.relStatus = 0
        z.value.relDesk = ""
            
              personModel.files.push(z.value);
              
            sendReSave(personModel)
      } else {
    
        modelForAdd.files.push(z)
      
      changeAdded()
      }
      
      
    
    
    
    }

    const addNewKan = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">Шифр: " + pers.shifrKan + "<br>Номер телефона: " + pers.lineKan
        z.innerHTML = s
        z.style.display = "block";
        z.value = Object.assign({}, pers);
        var p = Object.assign({}, pers);
        if (p.shifrKan == undefined || p.shifrKan == '') {
            z.value = pers
            p = pers

        }

        if (p.shifrKan == undefined || p.shifrKan == '') {
            showError('Шифр не може бути пустим')
            return;
        }

        if (p.lineKan == undefined || p.lineKan == '') {
            showError('Номер не може бути пустим')
            return;
        }

        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.kan.push(z.value);

            sendReSave()
        } else {
            modelForAdd.kan.push(z)

            changeAdded()
        }
    }

    const addNewTraitors = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">" + pers.nameTraitor + "<br>" + pers.bdate;
        z.innerHTML = s
        z.style.display = "block";
        z.value = Object.assign({}, pers);
        var p = Object.assign({}, pers);
        
        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.traitors.push(z.value);

            sendReSave()
        } else {
            modelForAdd.traitors.push(z)

            changeAdded()
        }
    }

    const changeAdded = () => {

        var a = document.getElementById("addeditems");
        a.innerHTML = ""
        if (document.getElementById("Person").style.display == "block") {
            for (let index = 0; index < modelForAdd.person.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.person[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20000])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.person[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.person[index].value.relStatus == undefined) {
                        modelForAdd.person[index].value.relStatus = 0
                    }
                    modelForAdd.person[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.persons.push(modelForAdd.person[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Зв\'язок', "checkbox1_" + modelForAdd.person[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.person[index].value.relStatus == undefined) {
                        modelForAdd.person[index].value.relStatus = 0
                    }
                    modelForAdd.person[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.persons.push(modelForAdd.person[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Родина', "checkbox2_" + modelForAdd.person[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.person[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.persons.push(modelForAdd.person[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                if (modelForAdd.person[index].value.relStatus == undefined) {
                    modelForAdd.person[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.person[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.person[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.person[index].value.relDesk == undefined) {
                    modelForAdd.person[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.person[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.person[index].innerHTML;
                const dlcl = i => () => {
                   sendPersonFullScreen(i)
                }
                d.ondblclick = dlcl(modelForAdd.person[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }

        if (document.getElementById("Address").style.display == "block") {
            for (let index = 0; index < modelForAdd.address.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.address[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20001])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.address[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.address[index].value.relStatus == undefined) {
                        modelForAdd.address[index].value.relStatus = 0
                    }
                    modelForAdd.address[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.address.push(modelForAdd.address[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Проживає', "checkbox1_" + modelForAdd.address[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.address[index].value.relStatus == undefined) {
                        modelForAdd.address[index].value.relStatus = 0
                    }
                    modelForAdd.address[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.address.push(modelForAdd.address[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Реєстрація', "checkbox2_" + modelForAdd.address[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.address[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.address.push(modelForAdd.address[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                var aaaa = modelForAdd.address[index].value
                if (modelForAdd.address[index].value.relStatus == undefined) {
                    modelForAdd.address[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.address[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.address[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.address[index].value.relDesk == undefined) {
                    modelForAdd.address[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.address[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.address[index].innerHTML;
                const dlcl = i => () => {
                    sendAddressFullScreen(i)
                 }
                 d.ondblclick = dlcl(modelForAdd.address[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }

        if (document.getElementById("Auto").style.display == "block") {
            for (let index = 0; index < modelForAdd.auto.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.auto[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20002])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.auto[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.auto[index].value.relStatus == undefined) {
                        modelForAdd.auto[index].value.relStatus = 0
                    }
                    modelForAdd.auto[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.auto.push(modelForAdd.auto[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Водить', "checkbox1_" + modelForAdd.auto[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.auto[index].value.relStatus == undefined) {
                        modelForAdd.auto[index].value.relStatus = 0
                    }
                    modelForAdd.auto[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.auto.push(modelForAdd.auto[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Володіє', "checkbox2_" + modelForAdd.auto[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.auto[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.auto.push(modelForAdd.auto[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                var aaaa = modelForAdd.auto[index].value
                if (modelForAdd.auto[index].value.relStatus == undefined) {
                    modelForAdd.auto[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.auto[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.auto[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.auto[index].value.relDesk == undefined) {
                    modelForAdd.auto[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.auto[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.auto[index].innerHTML;
                const dlcl = i => () => {
                    sendAutoFullScreen(i)
                 }
                 d.ondblclick = dlcl(modelForAdd.auto[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }

        if (document.getElementById("Company").style.display == "block") {
            for (let index = 0; index < modelForAdd.company.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.company[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20003])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.company[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.company[index].value.relStatus == undefined) {
                        modelForAdd.company[index].value.relStatus = 0
                    }
                    modelForAdd.company[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.company.push(modelForAdd.company[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Працює', "checkbox1_" + modelForAdd.company[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.company[index].value.relStatus == undefined) {
                        modelForAdd.company[index].value.relStatus = 0
                    }
                    modelForAdd.company[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.company.push(modelForAdd.company[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Керує', "checkbox2_" + modelForAdd.company[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.company[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.company.push(modelForAdd.company[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                var aaaa = modelForAdd.company[index].value
                if (modelForAdd.company[index].value.relStatus == undefined) {
                    modelForAdd.company[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.company[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.company[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.company[index].value.relDesk == undefined) {
                    modelForAdd.company[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.company[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.company[index].innerHTML;
                const dlcl = i => () => {
                    sendCompanyFullScreen(i)
                 }
                 d.ondblclick = dlcl(modelForAdd.company[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }

        if (document.getElementById("Contact").style.display == "block") {
            for (let index = 0; index < modelForAdd.contact.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.contact[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20004])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.contact[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.contact[index].value.relStatus == undefined) {
                        modelForAdd.contact[index].value.relStatus = 0
                    }
                    modelForAdd.contact[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.contact.push(modelForAdd.contact[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Об\'єкт', "checkbox1_" + modelForAdd.contact[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.contact[index].value.relStatus == undefined) {
                        modelForAdd.contact[index].value.relStatus = 0
                    }
                    modelForAdd.contact[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.contact.push(modelForAdd.contact[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Зв\'язок', "checkbox2_" + modelForAdd.contact[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.contact[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.contact.push(modelForAdd.contact[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                if (modelForAdd.contact[index].value.relStatus == undefined) {
                    modelForAdd.contact[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.contact[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.contact[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.contact[index].value.relDesk == undefined) {
                    modelForAdd.contact[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.contact[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.contact[index].innerHTML;
                const dlcl = i => () => {
                    sendContactFullScreen(i)
                 }
                 d.ondblclick = dlcl(modelForAdd.contact[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }
        if (document.getElementById("Proceedings").style.display == "block"){

            if (modelForAdd.proceedings != undefined) {
              var z = document.createElement('div'); // is a node
              var vv = document.createElement('div');
              vv.className = "itemAddView"
              z.style.display = "table";
    
              vv.style.display = "table-cell";
    
              modelForAdd.proceedings.style = "table-cell"
    
    
              
              
              var vb = document.createElement('div');
              vb.className = "itemAddButton"
              vb.innerHTML="<img width=\"100%\" src=\""+minus +"\"/>"
              var temp = modelForAdd.proceedings
              const cl = i => () =>{
                Swal.fire({
                    title: 'Підтвердіть виделаення запису',
                    icon: 'question',
                    html: '',
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Видалити',
                    denyButtonText: 'Оновити',
                    background: '#2B2B2B',
                    color: '#FFF'
                }).then((result) => {
                    if (result.isConfirmed) {
                    const queryParams = new URLSearchParams(window.location.search);
                    const id = queryParams.get("id");
                    var id2 = i.id
                    sendRemove([id, id2, 20007])
                    }
                })

    
    
                
                
              
              }
              vb.onclick = cl(modelForAdd.proceedings.value)
              
    
              
              vv.appendChild(vb)
    
              z.appendChild(vv);
              var d = document.createElement('div');
    
              d.innerHTML = modelForAdd.proceedings.innerHTML;
              d.ondblclick = modelForAdd.proceedings.ondblclick;
              
              z.appendChild(d);
                a.appendChild(z);
                
                
            }
    
          }
       
        if (document.getElementById("Traitor").style.display == "block") {
            for (let index = 0; index < modelForAdd.traitors.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.traitors[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20103])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.traitors[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.traitors[index].value.relStatus == undefined) {
                        modelForAdd.traitors[index].value.relStatus = 0
                    }
                    modelForAdd.traitors[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.traitors.push(modelForAdd.traitors[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Родина', "checkbox1_" + modelForAdd.traitors[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.traitors[index].value.relStatus == undefined) {
                        modelForAdd.traitors[index].value.relStatus = 0
                    }
                    modelForAdd.traitors[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.traitors.push(modelForAdd.traitors[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Зв\'язок', "checkbox2_" + modelForAdd.traitors[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.traitors[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.traitors.push(modelForAdd.traitors[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                if (modelForAdd.traitors[index].value.relStatus == undefined) {
                    modelForAdd.traitors[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.traitors[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.traitors[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.traitors[index].value.relDesk == undefined) {
                    modelForAdd.traitors[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.traitors[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.traitors[index].innerHTML;
                const dlcl = i => () => {
                    sendTraitorFullScreen(i)
                 }
                 d.ondblclick = dlcl(modelForAdd.traitors[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }

        if (document.getElementById("Kan").style.display == "block") {
            for (let index = 0; index < modelForAdd.kan.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.kan[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20101])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.kan[index].value)
                var chekers = document.createElement('div');
                chekers.className = "chekers"
                var checkbox1 = createChecker()
                checkbox1.onchange = function () {
                    if (modelForAdd.kan[index].value.relStatus == undefined) {
                        modelForAdd.kan[index].value.relStatus = 0
                    }
                    modelForAdd.kan[index].value.relStatus += (this.checked ? 1 : -1)
                    clearPersonModel()
                    personModel.kan.push(modelForAdd.kan[index].value);
                    sendReSave()
                };

                chekers.appendChild(checkbox1);
                chekers.appendChild(createCheckerLabel('Об\'єкт', "checkbox1_" + modelForAdd.kan[index].value));
                var checkbox2 = createChecker()
                checkbox2.onchange = function () {
                    if (modelForAdd.kan[index].value.relStatus == undefined) {
                        modelForAdd.kan[index].value.relStatus = 0
                    }
                    modelForAdd.kan[index].value.relStatus += (this.checked ? 2 : -2)
                    clearPersonModel()
                    personModel.kan.push(modelForAdd.kan[index].value);
                    sendReSave()
                };
                chekers.appendChild(document.createElement('br'));
                chekers.appendChild(checkbox2);
                chekers.appendChild(createCheckerLabel('Зв\'язок', "checkbox2_" + modelForAdd.kan[index].value));
                chekers.appendChild(document.createElement('br'));
                var input = createCheckerInput()
                input.onkeyup = function (event) {
                    if (event.key === 'Enter') {
                        modelForAdd.kan[index].value.relDesk = this.value
                        clearPersonModel()
                        personModel.kan.push(modelForAdd.kan[index].value);
                        sendReSave()
                    }
                };
                chekers.appendChild(input);
                if (modelForAdd.kan[index].value.relStatus == undefined) {
                    modelForAdd.kan[index].value.relStatus = 0
                } else {
                    checkbox1.checked = modelForAdd.kan[index].value.relStatus % 2 == 1
                    checkbox2.checked = modelForAdd.kan[index].value.relStatus / 2 >= 1
                }
                if (modelForAdd.kan[index].value.relDesk == undefined) {
                    modelForAdd.kan[index].value.relDesk = ""
                } else {
                    input.value = modelForAdd.kan[index].value.relDesk
                }
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.kan[index].innerHTML;
                const dlcl = i => () => {
                    sendKanFullScreen(i)
                 }
                 d.ondblclick = dlcl(modelForAdd.kan[index].value.id);
                z.appendChild(d);
                z.appendChild(chekers);
                a.appendChild(z);
            }

        }

        if (document.getElementById("MyDropzone").style.display == "block"){
        
        
                for (let index = 0; index < modelForAdd.photo.length; index++) {
                  var z = document.createElement('div'); // is a node
                  var vv = document.createElement('div');
                  vv.className = "itemAddView"
                  z.style.display = "table";
        
                  vv.style.display = "table-cell";
        
                  modelForAdd.photo[index].style = "table-cell"
        
        
                  
                  
                  var vb = document.createElement('div');
                  vb.className = "itemAddButton"
                  vb.innerHTML="<img width=\"100%\" src=\""+minus +"\"/>"
                  const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20009])
                        }
                    })
                }
                  vb.onclick = cl(modelForAdd.photo[index].value)
                  var chekers = document.createElement('div');
                  chekers.className = "chekers"
        
                  var input = createCheckerInput();
                  
                  input.onkeyup = function (event) {  
                    if(event.key === 'Enter'){
                      modelForAdd.photo[index].value.text = this.value
        
                      clearPersonModel()
                    personModel.photo.push(modelForAdd.photo[index].value);
                          
                    sendReSave(personModel) 
                    
                    }
                    
                    
                };
                  chekers.appendChild(input);
                  
                  if(modelForAdd.photo[index].value.text == undefined) {
                    modelForAdd.photo[index].value.text = ""
                  } else {
                    input.value = modelForAdd.photo[index].value.text
                  }
                  
                  vv.appendChild(vb)
        
        
                  /*const cl = i => () =>{
                    pp(i)
                  }*/
                  
                  //z.onclick = cl(pers.id)
                  z.appendChild(vv);
                  var d = document.createElement('div');
        
                  d.innerHTML = modelForAdd.photo[index].innerHTML;
                  d.ondblclick = modelForAdd.photo[index].ondblclick;
                  
                  z.appendChild(d);
                  z.appendChild(chekers);
                    a.appendChild(z);
                    
                    
                }
        
                for (let index = 0; index < modelForAdd.files.length; index++) {
                  var z = document.createElement('div'); // is a node
                  var vv = document.createElement('div');
                  vv.className = "itemAddView"
                  z.style.display = "table";
        
                  vv.style.display = "table-cell";
        
                  modelForAdd.files[index].style = "table-cell"
        
        
                  
                  
                  var vb = document.createElement('div');
                  vb.className = "itemAddButton"
                  vb.innerHTML="<img width=\"100%\" src=\""+minus +"\"/>"
                  const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20008])
                        }
                    })
                }
                  vb.onclick = cl(modelForAdd.files[index].value)
                  var chekers = document.createElement('div');
                  chekers.className = "chekers"
        
                  var input = createCheckerInput()
                  
                  input.onkeyup = function (event) {  
                    
                    if(event.key === 'Enter'){
                      modelForAdd.files[index].value.text = this.value
        
                  clearPersonModel()
                    personModel.files.push(modelForAdd.files[index].value);
                          
                    sendReSave(personModel) 

                    }
                    
                };
                  chekers.appendChild(input);
                  
                  if(modelForAdd.files[index].value.text == undefined) {
                    modelForAdd.files[index].value.text = ""
                  } else {
                    input.value = modelForAdd.files[index].value.text
                  }
                  
                  vv.appendChild(vb)
        
        
                  /*const cl = i => () =>{
                    pp(i)
                  }*/
                  
                  //z.onclick = cl(pers.id)
                  z.appendChild(vv);
                  var d = document.createElement('div');
        
                  d.innerHTML = modelForAdd.files[index].innerHTML;
                  d.ondblclick = modelForAdd.files[index].ondblclick;
                  
                  z.appendChild(d);
                  z.appendChild(chekers);
                    a.appendChild(z);
                    
                    
                }
        
              }
    }









    return (
        <div className="fixed inset-0 bg-black z-50">

            <div className="main">
                <div className="header">
                    <img src={logo} className="logo" alt="logo" />
                    <div className="title" onClick={mainSubmit}>SPACE</div>
                    <div className="subtitle">(edit) </div>

                </div>

                <div className="panel">

                    <button id="personsB" className="panelButtonActive-opm" onClick={profileSubmit} >
                        <img src={persons} className="panelImage" />
                    </button>
                    <button id="homeB" className="panelButton-opm" onClick={homeSubmit} >
                        <img src={home} className="panelImage" />
                    </button>
                    <button id="carB" className="panelButton-opm" onClick={carSubmit} >
                        <img src={car} className="panelImage" />
                    </button>
                    <button id="companyB" className="panelButton-opm" onClick={companySubmit} >
                        <img src={company} className="panelImage" />
                    </button>
                    <button id="phoneInternerB" className="panelButton-opm" onClick={phoneInternerSubmit} >
                        <img src={phoneInterner} className="panelImage" />
                    </button>
                   
                    <button id="eventB" className="panelButton-opm" onClick={eventSubmit} >
                        <img src={event} className="panelImage" />
                    </button>
                    <button id="crimeB" className="panelButton-opm" onClick={traitorSubmit} >
                        <img src={crime} className="panelImage" />
                    </button>
                    <button id="headPhoneB" className="panelButton-opm" onClick={kanzSubmit} >
                        <img src={headPhone} className="panelImage" />
                    </button>
                    <button id="clipB" className="panelButton-opm" onClick={clipSubmit} >
                        <img src={clip} className="panelImage" />
                    </button>
                </div>

                <div className="searchMenu">

                    <form onSubmit={handleSubmit} className="form">


                        <input id="saveButton" className="input-button-right-opm" type="submit" value="Зберегти" />



                        <div id="storageADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="storageA" className="input-text" tabIndex="8" name="login" type="text" onChange={storagechange}  placeholder="Зберігання" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="storageAList" className="list" />
          </div>

          <div id="ini_nameADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="ini_nameA" className="input-text" tabIndex="7" name="login" type="text" onChange={ini_namechange}  placeholder="Ініціатор" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="ini_nameAList" className="list" />
          </div>

          <div id="ini_directionADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="ini_directionA" className="input-text" tabIndex="6" name="login" type="text" onChange={ini_directionchange}  placeholder="Відділ ініціатора" autoComplete="off"onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="ini_directionAList" className="list" />
          </div>

          <div id="ini_organADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="ini_organA" className="input-text" tabIndex="5" name="login" type="text" onChange={ini_organchange}  placeholder="Підрозділ ініціатора" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="ini_organAList" className="list" />
          </div>

          <div id="executorADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="executorA" className="input-text" tabIndex="4" name="login" type="text" onChange={executorchange}  placeholder="Виконавець" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="executorAList" className="list" />
          </div>

          <div id="typeExecutorADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="typeExecutorA" className="input-text" tabIndex="3" name="login" type="text" onChange={typeExecutorchange}  placeholder="Підрозділ виконавця" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="typeExecutorAList" className="list" />
          </div>

          <div id="dateOPMADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="dateOPMA" className="input-text" tabIndex="2" name="login" type="text" onChange={dateOPMchange}  placeholder="Дата" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="dateOPMAList" className="list" />
          </div>

          <div id="numberOPMADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="numberOPMA" className="input-text" tabIndex="1" name="login" type="text" onChange={numberOPMchange}  placeholder="Номер" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="numberOPMAList" className="list" />
          </div>


                    </form>

                </div>

                <div className="searc2hMenu" >
                    <div id="Person" className="menuItems" style={{ display: "block" }}>
                        <Person changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Address" className="menuItems" style={{ display: "none" }}>
                        <Address changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Auto" className="menuItems" style={{ display: "none" }}>
                        <Auto changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Company" className="menuItems" style={{ display: "none" }}>
                        <Company changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Contact" className="menuItems" style={{ display: "none" }}>
                        <Contact changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Document" className="menuItems" style={{ display: "none" }}>
                        <Document changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Gun" className="menuItems" style={{ display: "none" }}>
                        <Gun changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Proceedings" className="menuItems" style={{ display: "none" }}>
                        <Proceedings changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Traitor" className="menuItems" style={{ display: "none" }}>
                        <Traitor changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="Kan" className="menuItems" style={{ display: "none" }}>
                        <Kan changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="BS" className="menuItems" style={{ display: "none" }}>
                        <BS changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                    <div id="MyDropzone" className="menuItems" style={{ display: "none" }}>
                        <MyDropzone addNew={addNew} />
                    </div>

                </div>


                <table width="100%" style={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }} >
                    <tbody>
                        <td style={{ width: "350px", maxWidth: "350px", overflow: "hidden", whiteSpace: "nowrap" }}>

                        </td>
                        <td style={{ width: "600px", maxWidth: "600px", overflow: "hidden", wordWrap: "break-word" }}>
                            <div id="addeditems">

                            </div>
                        </td>
                        <td id="tdline" style={{ width: "1px", maxWidth: "1px", overflow: "hidden" }}>
                            <div id="line">

                            </div>
                        </td>
                        <td style={{ width: "600px", maxWidth: "600px", overflow: "hidden", wordWrap: "break-word" }}>
                            <div id="foundItems">

                            </div>
                        </td>
                        <td style={{ width: "350px", maxWidth: "350px", overflow: "hidden", whiteSpace: "nowrap" }}>

                        </td>
                        <tr>
                            <td style={{ width: "350px" }}>

                            </td>
                            <td colSpan="3" id="suneditor" >

                                <SunEditor getSunEditorInstance={getSunEditorInstance}
                                    id="textView" name="textView" height="300px" setOptions={{
                                        pasteTagsWhitelist: 'p,br,ul,ol,li,strong,b,em,i,span,div',
                                        addTagsWhitelist: 'p,br,ul,ol,li,strong,b,em,i,span,div',
                                        pastePlain: false,
                                        pasteImage: false,
                                        removeFormat: {
                                        tag: 'font',
                                        class: 'Mso*', 
                                        style: 'color,background-color,font-family'
                                        },
                                        buttonList: [['undo', 'redo',
                                            'font', 'fontSize', 'formatBlock',
                                            'paragraphStyle', 'blockquote', 'textStyle'
                                        ], ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript',
                                            'fontColor', 'hiliteColor',
                                            'outdent', 'indent',
                                            'align', 'horizontalRule', 'list', 'lineHeight']]
                                    }}
                                    setAllPlugins={true}
                                    setDefaultStyle="font-family: Arial; font-size: 14px; text-align: justify;"
                                    onChange={content => {

                                        personModel.info = content
                                        // console.log(content)

                                    }} />

                            </td>
                            <td style={{ width: "350px" }}>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            ({isBlocked && <div className={`black ${isBlocked ? "show" : ""}`}>
                <img src={loading} alt="logo" />

            </div>
            })
        </div>

    );
}


export default OPMEdit;